import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitByUppercase',
    standalone: false
})

export class SplitByUppercasePipe implements PipeTransform {
  public transform(myStr: string): string {
    let result = '';
    if (myStr) myStr.match(/[A-Z][a-z]+/g).forEach((str, i) => {
      if (!!i) result += ' ';
      result += str;
    });
    return result;
  }
}
